import { createApiHook } from '../hooks';
import { creativesApiFactory } from './creativesApiFactory';

export const useCreativesApi = createApiHook(creativesApiFactory);
